<!--  -->
<template>
    <div>
        <div class="question-suggestion-upload">
            <uploader v-model="fileList" result-type="file" :accept="accept" :show-upload="showDelete" :deletable="showDelete" @delete="deleteFile" :max-count="maxCount" :before-read="beforeRead" :after-read="afterRead">
                <div v-if="showDelete" class="container">
                    <div class="container-center">
                        <div class="container-center-add">
                            <img src="@/assets/images/suggestion/add.png" alt="" />
                        </div>
                        <div>上传凭证</div>
                    </div>
                </div>
            </uploader>
        </div>
    </div>
</template>

<script>
import { Uploader } from 'vant'
import { uploadImage } from '@/api/api'
import { beforeRead, handleChangeUrl } from '@/libs/tools'
export default {
    name: 'Upload',
    components: {
        Uploader
    },
    props: {
        // 文件路径
        url: {
            type: String,
            default: ''
        },
        // 是否能删除
        showDelete: {
            type: Boolean,
            default: true
        },
        // 最大上传数
        maxCount: {
            type: Number,
            default: 3
        },
        accept: {
            type: String,
            default: 'image/png,image/jpeg'
        }
    },
    data() {
        // {
        // deletable: true,

        // }
        return {
            fileList: []
        }
    },

    computed: {

    },
    watch: {
        url: {
            handler(newValue, oldValue) {
                if (!newValue) { this.fileList = [] } else {
                    this.fileList = newValue.split(',').map(item => {
                        return {
                            status: 'done',
                            url: item
                        }
                    })
                }
            }
        }
    },
    mounted() { },

    methods: {
        beforeRead,
        afterRead(file) {
            file.status = 'uploading'
            file.message = '上传中...'
            uploadImage(file.file).then((res) => {
                if (res.code == 200) {
                    file.status = 'done'
                    file.url = res.data.imgUrl
                    this.updateUrl(res.data.imgUrl)
                }
            })
        },

        updateUrl(url) {
            let urlStr = ''
            if (this.url) urlStr = this.url + ',' + url
            else {
                urlStr = url
            }
            this.$emit('update:url', urlStr)
        },
        deleteFile() {
            let urlStr = this.fileList.map(item => item.url).join(',')
            this.$emit('update:url', urlStr)
        }
    }
}

</script>
<style lang="less" scoped>
.upload-button {
    background-color: #fff;
    color: #009af3;
    border: 1px #00c6ea solid;
    border-radius: 5px;
    height: 44px;

    img {
        height: 20px;
        width: 17px;
    }
}

.see {
    // display: flex;
    // align-items: center;
    font-size: 13px;
    color: #008bfb;

    img {
        height: 21px;
        width: 21px;
    }
}

.delete {
    font-size: 13px;

    color: #fb0000;
}

.question-suggestion-upload {
    min-height: 160px;

    .container {
        height: 160px;
        width: 160px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #f5f5f5;
        color: #777777;

        .container-center {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .container-center-add {
                margin: 10px 0;
            }
        }

        img {
            height: 44px;
            width: 44px;
        }
    }
}
</style>
